import { render, staticRenderFns } from "./ImportPromotions.vue?vue&type=template&id=25dff21c&"
import script from "./ImportPromotions.vue?vue&type=script&lang=js&"
export * from "./ImportPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports